var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "cms-view",
    { staticClass: "view-logger-create-selection" },
    [
      _c("cms-heading", {
        attrs: { title: "Selectie maken", icon: "magicon-ok-circle" },
      }),
      _c("cms-panel", [
        _c(
          "div",
          { staticClass: "add-ean-holder" },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.serialNumber,
                  expression: "serialNumber",
                  modifiers: { trim: true },
                },
              ],
              ref: "serialNumberInput",
              staticClass: "input-normal",
              attrs: {
                placeholder: "Voer het serienummer van een logger in...",
              },
              domProps: { value: _vm.serialNumber },
              on: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  $event.preventDefault()
                  return _vm.searchLogger(true)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.serialNumber = $event.target.value.trim()
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _c(
              "cms-button",
              {
                attrs: {
                  icon: "magicon-plus",
                  color: "positive",
                  disabled: !_vm.serialNumber,
                  loading: _vm.fetchingLogger,
                },
                on: {
                  click: function ($event) {
                    return _vm.searchLogger(false)
                  },
                },
              },
              [_vm._v("Toevoegen")]
            ),
          ],
          1
        ),
      ]),
      _c("cms-heading", {
        attrs: {
          title: _vm.loggers.length + " logger(s) geselecteerd",
          level: "2",
        },
      }),
      _c(
        "cms-table-panel",
        {
          attrs: {
            placeholder: !_vm.loggers.length,
            "placeholder-text": "Nog geen loggers geselecteerd",
          },
        },
        [
          _c("tr", [
            _c("th", [_vm._v("Serienummer")]),
            _c("th", [_vm._v("Type")]),
            _c("th", [_vm._v("Status")]),
            _c(
              "th",
              [
                _vm._v("Opmerkingen bij statuswisseling "),
                _c("cms-info-icon", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Wordt opgeslagen bij statuswisseling",
                      expression: "'Wordt opgeslagen bij statuswisseling'",
                    },
                  ],
                }),
              ],
              1
            ),
            _c("th"),
          ]),
          _vm._l(_vm.loggers, function (logger) {
            return _c("tr", [
              _c("td", [_vm._v(_vm._s(logger.serialNumber))]),
              _c("td", [_vm._v(_vm._s(logger.type.title))]),
              _c(
                "td",
                [
                  _c("cms-text-label", {
                    attrs: {
                      title: _vm._f("loggerState")(logger.state),
                      color: _vm._f("loggerStateColor")(logger.state),
                    },
                  }),
                ],
                1
              ),
              _c("td", { staticClass: "comments" }, [
                _c("textarea", {
                  staticClass: "textarea-normal",
                  attrs: { rows: "1" },
                  domProps: { value: _vm.comments[logger.id] },
                  on: {
                    input: function ($event) {
                      return _vm.updateComment(logger, $event.target.value)
                    },
                  },
                }),
              ]),
              _c(
                "td",
                { staticClass: "actions" },
                [
                  _c("cms-link", {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: "Verwijder uit selectie",
                        expression: "'Verwijder uit selectie'",
                      },
                    ],
                    attrs: { icon: "magicon-minus-circle" },
                    on: {
                      click: function ($event) {
                        return _vm.deleteSelection(logger)
                      },
                    },
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
      _c("logger-action-grid", {
        attrs: { entries: _vm.entries },
        on: { executed: _vm.onActionExecuted },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }